export const MainColor = "#7C1E7C";

export enum AdditionalColors {
  DarkOrchid = "#ff7f3f",
  Dark = "#131312",
  SteelBlue = "#6E7F8D",
  RoyalPurple = "#805cf5",
  Fuchsia = "#FF486F",
  Yellow = "#f5cc28",
  Blue = "#64B3FC",
  Purple = "#A664FC",
  OceanBlue = "#08C9C3",
}

export enum ColorsPresets {
  Main = "main",
  Secondary = "secondary",

  Black = "black",
  White = "white",
  Taker = "taker",
  Dook = "dook",

  GrayLine = "grayLine",
  Gray1 = "gray1",
  Gray2 = "gray2",
  Gray3 = "gray3",
  Gray4 = "gray4",
  Gray5 = "gray5",

  BlueGray = "blueGray",
  Bg1 = "bg1",
  Bg2 = "bg2",
  Bg3 = "bg3",
  Bg4 = "bg4",

  Danger = "danger",
  Danger10 = "danger10",
  Success = "success",
  Blue = "blue",
  Green = "green",

  SuccessLight = "successLight",
  MainLight = "mainLight",
  DookLight = "dookLight",

  Transparent = "transparent",
}
